import classNames from 'classnames/bind';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'uikit/Button';
import CheckBox from 'uikit/CheckBox';

import styles from './GAR.module.scss';

const cx = classNames.bind(styles);

const GAR = ({ garDIV, garGRO, handleSave, initialValues, t }) => (
  <>
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSave}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className={cx('checkboxes')}>
            {garDIV.length > 0 && (
              <>
                <h2 className={cx('subtitle')}>
                  {t('Course/Teacher/Cover/CourseShare/GAR/divisions')}
                </h2>

                {garDIV.map((div) => {
                  const [key, name] = div.split('##');
                  return (
                    <CheckBox
                      className={cx('checkbox')}
                      key={div}
                      name={`div.${div}`}
                      label={`${name} (${key})`}
                    />
                  );
                })}
              </>
            )}
            {garGRO.length > 0 && (
              <>
                <h2 className={cx('subtitle')}>
                  {t('Course/Teacher/Cover/CourseShare/GAR/groups')}
                </h2>
                {garGRO.map((gro) => {
                  const [key, name] = gro.split('##');
                  return (
                    <CheckBox
                      className={cx('checkbox')}
                      key={gro}
                      name={`gro.${gro}`}
                      label={`${name} (${key})`}
                    />
                  );
                })}
              </>
            )}
          </div>
          <Button
            className={cx('action')}
            intent="primary"
            isLoading={isSubmitting}
            size="large"
            type="submit"
          >
            {t('Course/Teacher/Cover/CourseShare/GAR/share')}
          </Button>
        </Form>
      )}
    </Formik>
  </>
);

GAR.propTypes = {
  garDIV: PropTypes.arrayOf(PropTypes.string),
  garGRO: PropTypes.arrayOf(PropTypes.string),
  handleSave: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

GAR.defaultProps = {
  garDIV: [],
  garGRO: [],
};

export default GAR;
